import api from "../../../Component/axios";

export const useCultivo = () => {
  const getCultivo = async () => {
    const token = localStorage.getItem("@Token");
    const codigo_campo = localStorage.getItem("codigo_campo");

    try {
      const response = await api.post(
        "api/cultivo/get/cultivo-por-campo",
        {
          data: codigo_campo,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Token " + token,
          },
        }
      );
      return response.data;
    } catch (error) {
      console.log(error);
    }
  };

  return { getCultivo };
};
